import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, getStoredAdmin, setStoredAdmin } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(getStoredAdmin());
  const [loading, setLoading] = useState(!!getToken());

  useEffect(() => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setAdmin(r.data);
        setStoredAdmin(r.data);
      })
      .catch(() => {
        setToken(null);
        setStoredAdmin(null);
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const signIn = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setStoredAdmin(data.admin);
    setAdmin(data.admin);
    return data.admin;
  };

  const signOut = () => {
    setToken(null);
    setStoredAdmin(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, signIn, signOut, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
